module.exports = "<ext-wcm-html-content file-content=\"vm.fileContent\"></ext-wcm-html-content>\r\n";